import React from 'react';
import { TextField } from '../../../components/TextField';
import type { FilterComponentProps } from './types';
import { accessibilityLabel } from './utils';

export const TextFieldFilter: React.FC<FilterComponentProps> = ({
  columnDef,
  onFilterChanged,
}: FilterComponentProps) => {
  const { tableData } = columnDef;

  if (!tableData) {
    return null;
  }

  // Controlled by material-table's filter state so a remount of this input doesn't drop the
  // user's typed text while the row data is still filtered by it.
  const value = typeof tableData.filterValue === 'string' ? tableData.filterValue : '';

  return (
    <TextField
      inputElementProps={{ 'aria-label': accessibilityLabel(columnDef) }}
      onChange={(event) => onFilterChanged(tableData.id, event.target.value)}
      type="search"
      value={value}
      variant="standard"
    />
  );
};
